
    import {defineComponent, h, reactive} from 'vue'
    import {useRoute} from "vue-router";
    import {useStore} from '@/store';
    import utils from '@/util/index';
    import {GetReportViewModelFromJSON, GetReportViewModelFromServe, GetIdleFishReportService, GetIdleFishReportJSON} from '@/service';

    let nameList = [
        'ReportCarInfo',
        'ReportResult',
        'BaseInfo',
        'ConfigInfo',
        'checkDetail',
        'AccidentCheck',
        'FireCheck',
        'WaterCheck',
        'EnsureService',
        'Reminder',
    ]
    let idlefishList = [
        'HeaderReport',
        'ReportCarInfo',
        'ReportResult',
        'AbnormalCheck',
        'TotalCheck',
        'AccidentCheck',
        'FireCheck',
        'WaterCheck',
        'BaseInfo',
        'ConfigInfo',
        'ServiceInfo',
        'DateReport',
        'RatingCriteria',
        'Reminder',
        'FooterReport'
    ]
    let list: any[] = [];
    let components = {};
    let urlParam: any = utils.parseQueryString('');
    let sealType = urlParam.sealType ? urlParam.sealType : '';
    // 闲鱼普通&闲鱼优品
    if (sealType) {
        idlefishList.forEach(item => {
            if (!components[item]) {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const model = require(`./_components/${item}.vue`)['default'];
                list.push(model)
                components[item] = model
            } else {
                list.push(components[item])
            }
        });
    } else {
        nameList.forEach(item => {
            if (!components[item]) {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const model = require(`./components/${item}.vue`)['default'];
                list.push(model)
                components[item] = model
            } else {
                list.push(components[item])
            }
        })
    }

    interface State {
        sealType: string;
    }
    export default defineComponent({
        name: "idlefish_index",
        components,
        setup() {
            let state: State = reactive({
                sealType: ''
            })
            document.title="验货报告"
            const {query} = useRoute();
            const {reportCode, reportLevel, sealType} = query
            state.sealType = String(sealType) || '';
            let store = useStore()
            // 先尝试json文件
            if (state.sealType === 'xianyu') {
                GetIdleFishReportJSON({reportCode}).then((res: any) => {
                    store.dispatch('saveDataInfo', res)
                }).catch((err) => {
                    if (err.message.indexOf('404')) {
                        // json文件404了请求直连接口
                        GetIdleFishReportService({reportCode}).then((res: any) => {
                            store.dispatch('saveDataInfo', res)
                        }).catch((err) => {
                            // eslint-disable-next-line
                            console.error(err)
                        })
                    } else {
                        // eslint-disable-next-line
                        console.error(err)
                    }
                })
            } else {
                GetReportViewModelFromJSON({reportCode}).then((res: any) => {
                    store.dispatch('saveDataInfo', res)
                }).catch((err) => {
                    if (err.message.indexOf('404')) {
                        // json文件404了请求直连接口
                        GetReportViewModelFromServe({reportCode, reportLevel}).then((res: any) => {
                            store.dispatch('saveDataInfo', res)
                        }).catch((err) => {
                            // eslint-disable-next-line
                            console.error(err)
                        })
                    } else {
                        // eslint-disable-next-line
                        console.error(err)
                    }
                })
            }
            
            return {
                state
            }
        },
        render() {
            return h('div', {class: this.state.sealType === 'xianyu' ? 'main__bg_fish_good' : 'main__bg_fish'}, list.map((item, index) =>
                h(item, {}, index)
            ));
        }
    });
